// extracted by mini-css-extract-plugin
module.exports = {"component":"tooltip-arrow_component__1HAih","icon":"tooltip-arrow_icon__HpFXb"};